import { useEffect } from 'react'
import { externalUrls } from 'consts'

interface useProcessFiltersProps {
    filterParams: any
    allFilterParams: any
    setAllFilterParams: Function
    pageFilterParams?: any
    setReportUrl: Function
    setReportQueryString: Function
    reportId: number
    token: string | false
    height: string
    isLoaded: boolean
    isPageFilterBarLoaded: boolean
    reportFilterCount: null | number
    pageFilterCount?: null | number
}

const useProcessFilters = (props: useProcessFiltersProps) => {
    useEffect(() => {   
        
        let newFilterParams = {}

        // params to url
        for (const param of Object.keys(props.filterParams)) {
            const value = props.filterParams[param]
            newFilterParams = {...newFilterParams, [param]: value}
        }
        
        for (const param of Object.keys(props.pageFilterParams)) {
            const value = props.pageFilterParams[param]
            newFilterParams = {...newFilterParams, [param]: value}
        }

        
        let queryString = '?id=' + props.reportId + '&token=' + props.token + '&height=' + props.height + '&theme=theme-2'
        
        
        const urlFilterParams = {...newFilterParams}
        props.setAllFilterParams(urlFilterParams)
        // remove params that we set to null / undefined / '', see setFilterParam
        // for (const param of Object.keys(urlFilterParams)) {
        //     if (!(param in props.filterParams)) {
        //       delete urlFilterParams[param];
        //     }
        // }
        
        // params to url
        for (const param of Object.keys(urlFilterParams)) {
            let value = urlFilterParams[param]
            //do not pass empty string value to a query string
            if(value === ''){
                continue
            }
            if(Array.isArray(value)){
                value = value.join(',')
            }
            queryString += '&' + param + '=' + value
        }
        
         if(
            props.isLoaded === true 
            && props.isPageFilterBarLoaded === true 
            && props.reportFilterCount !== null 
            && props.reportFilterCount === Object.keys(props.filterParams).length
            && (props.pageFilterCount === undefined || (props.pageFilterParams !== undefined && Object.keys(props.pageFilterParams).length === props.pageFilterCount))
        ){
            props.setReportQueryString(queryString)
            props.setReportUrl(externalUrls.visualizeReport + queryString)
        }
       

    }, [props.filterParams, props.pageFilterParams, props.isLoaded, props.isPageFilterBarLoaded, props.reportFilterCount, props.pageFilterCount])
}

export default useProcessFilters